import { MdOutlineFileDownload } from 'react-icons/md';
import { KnowYourCustomerData } from '@blisspointmedia/bpm-types/dist/KnowYourCustomer';
import { IconButton } from '@Components/IconButton';
import { downloadJSONToCSV } from '../../utils/download-utils';
import { useCompanyInfo } from '../../utils/hooks/useCompanyInfo';
import {
  CUSTOMER_INSIGHTS_PRETTY_NAMES,
  CustomerInsightsFields
} from './customer-insights-constants';

interface ChartContainerRightActionsProps {
  fieldName: CustomerInsightsFields;
  data: KnowYourCustomerData[];
}

export const ChartContainerRightActions = ({
  fieldName,
  data
}: ChartContainerRightActionsProps) => {
  const fieldPrettyName = CUSTOMER_INSIGHTS_PRETTY_NAMES[fieldName];
  const { cid, name } = useCompanyInfo();
  const companyName = cid === 'tinuititest' ? 'Tinuiti' : name;

  const handleDownload = () => {
    const formattedData = data.map(row => ({
      'Demographic Category': fieldPrettyName,
      'Demographic Group': row.levels,
      [`${companyName}'s Population`]: Math.round(row.clientPopulation),
      [`${companyName}'s Distribution`]: row.clientPopulationFraction,
      'US Market': Math.round(row.tuPopulation),
      'US Market Distribution': row.tuPopulationFraction,
      Index: row.clientPopulationFraction / row.tuPopulationFraction,
      Penetration: row.clientPopulation / row.tuPopulation
    }));
    const date = new Date();
    downloadJSONToCSV(
      formattedData,
      `CustomerInsights ${companyName} ${fieldPrettyName} ${date.toLocaleString()}`
    );
  };

  return (
    <IconButton onClick={handleDownload}>
      <MdOutlineFileDownload />
    </IconButton>
  );
};
